/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { ArrowLeft } from 'lucide-react';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { PageHeader } from '../../components/ui/page-header.js';
import { useClients } from '../../lib/queries/clinical.js';
import { HomeTasksPanel } from '../home-tasks/home-tasks-panel.js';

/** Therapist → client Home Tasks (Figma "Assign Home Tasks"). Assign + review. */
export function TherapistClientHomeTasksPage(): JSX.Element {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const clients = useClients();
  const client = (clients.data ?? []).find((c) => c.id === id);

  return (
    <div className="p-8">
      <Link
        to="/therapist/clients"
        className="focus-ring mb-4 inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        {t('therapist.homeTasks.back')}
      </Link>
      <PageHeader
        title={t('therapist.homeTasks.title')}
        subtitle={client?.fullName ?? t('therapist.homeTasks.subtitle')}
      />
      {id !== undefined && <HomeTasksPanel clientId={id} canAssign />}
    </div>
  );
}
